/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import { camelCase } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { getComponentFromName } from '../../lib/utils';

import { useSite } from '../../contexts/SiteContext';

import styles from '../../../styles/blocks/blocks.module.css';

const propTypes = {
    blocks: PropTypes.arrayOf(PropTypes.shape({})),
    components: PropTypes.shape({}),
    className: PropTypes.string,
    blockClassName: PropTypes.string,
    padded: PropTypes.bool,
    withoutLines: PropTypes.bool,
    isContainer: PropTypes.bool,
    isLeftAligned: PropTypes.bool,
    containerClassName: PropTypes.string,
    blockTypeClassNames: PropTypes.objectOf(PropTypes.string),
};

function BaseBlocks({
    blocks = [],
    components = null,
    className = null,
    blockClassName = null,
    padded = true,
    withoutLines = false,
    isContainer = false,
    isLeftAligned = false,
    containerClassName = null,
    blockTypeClassNames = null,
}) {
    const { handle = null } = useSite();
    const weekStyled = handle === 'semainedudoc';
    const finalWithoutLines = withoutLines || weekStyled;
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.withoutLines]: finalWithoutLines,
                    [className]: className !== null,
                },
            ])}
        >
            {(blocks || []).map((block, index) => {
                const { type } = block || {};
                const BlockComponent = getComponentFromName(type, components);
                if (BlockComponent === null && process.env.NODE_ENV === 'development') {
                    // eslint-disable-next-line no-console
                    console.warn(`Missing block ${type}`);
                }
                const isLastBlock = index === blocks.length - 1;
                return BlockComponent !== null ? (
                    <div
                        key={`block-${block?.id}`}
                        className={classNames([
                            styles.block,
                            {
                                [styles[camelCase(type)]]:
                                    typeof styles[camelCase(type)] !== 'undefined',
                                [styles.isLast]: isLastBlock,
                                [blockClassName]: blockClassName !== null,
                                [(blockTypeClassNames || {})[camelCase(`block-${type}`)]]:
                                    ((blockTypeClassNames || {})[camelCase(`block-${type}`)] ||
                                        null) !== null,
                            },
                        ])}
                    >
                        <BlockComponent
                            id={block.id}
                            isLast={isLastBlock}
                            isContainer={isContainer}
                            isLeftAligned={isLeftAligned}
                            withoutLines={finalWithoutLines}
                            className={styles[`block-${type}`]}
                            containerClassName={containerClassName}
                            padded={padded}
                            {...block}
                        />
                    </div>
                ) : null;
            })}
        </div>
    );
}

BaseBlocks.propTypes = propTypes;

export default BaseBlocks;
